import config from '../config.js';

export const fetchClient = async (path , options = {}, host = config.roenBackendURL) => {
  const url = `${host}${path}`;

  if(!options.method) options.method = 'GET';
  if(!options.credentials) options.credentials = 'include';
  if(!options.headers) options.headers = { 'Content-Type': 'application/json' };

  const response = await fetch(url, options);
  if (response.ok) {
    let responseBody = {};

    // Immediate return if no body in succcessfull response
    // Else some browsers in mobiles start complaining about mal formed responses
    if (response.status === 204) {
      return { status: response.status, body: responseBody, response };
    }

    try {
      responseBody = await response.clone().json();
    } catch (error) {
      if (!error.message.includes('Unexpected end of JSON input')) {
        console.error('fetchClient error', error.message, host, path, JSON.stringify(options), response.status, JSON.stringify(response));
        throw error;
      }
    }

    return { status: response.status, body: responseBody, response };
  } else if (response.status === 401) {
    window.localStorage.setItem('user', null);
    window.location.replace('/login');
    return { status: response.status, response };
  } else if (response.status === 402) {
    window.location.replace('/billing');
    return { status: response.status, response };
  } else {
    return { status: response.status, response };
  }
};
